export * from './brief-location-info.interface';
